/**
 * Resolves the true deployment environment.
 *
 * Priority:
 * 1. NEXT_PUBLIC_VERCEL_ENV — available client+server on Vercel (set via next.config.mjs env)
 * 2. VERCEL_ENV — server-only on Vercel (fallback for SSR code before next.config.mjs mapping)
 * 3. NODE_ENV / CI heuristics — local development, CI, or local production build
 *
 * This exists because NODE_ENV is always 'production' in any built Next.js app,
 * making it useless as a deployment environment indicator.
 */
export function getDeploymentEnvironment(): string {
  const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV;
  if (vercelEnv) return vercelEnv;

  const nodeEnv = process.env.NODE_ENV;
  if (nodeEnv === 'development') return 'development';
  if (nodeEnv === 'test') return 'test';
  if (process.env.CI === 'true') return 'ci';
  return 'local';
}
